import { vars } from "@common/styles";
import styled from "styled-components";

export const Button = styled.button`
  color: ${vars.colors.sky};
  border-radius: 1.4rem;
  padding: 0 0.5rem;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  border: 1px solid transparent;
  background-image: linear-gradient(#2a3641, #2a3641), linear-gradient(90deg, #64b1fd, #3c6a97);
  background-origin: padding-box, border-box;
  background-clip: padding-box, border-box;
  margin-right: 1px;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    path {
      stroke: ${vars.colors.sky};
    }
  }
`;

export const Number = styled.div`
  background-color: ${vars.colors.grey90};
  border-radius: 50%;
  width: 2.2rem;
  height: 2.2rem;
  min-width: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  margin-bottom: 0.1rem;
`;
